import React, { Fragment, useState, useMemo, useEffect } from 'react'
import injectSheet from 'react-jss'
import styles from './lessons.styles'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import LessonsList from '../lessons-list/lessons-list'
import LessonsContext from './lessons.context'
import PendingTeacherBar from 'pobble-components/dist/pending-teacher-bar'
import { PromptsLayout } from '../../prompts-layout'

const Lessons = ({ classes }) => {
  const match = useRouteMatch()
  const [createLessonOpened, setCreateLessonOpened] = useState(false)
  const value = useMemo(
    () => ({
      setCreateLessonOpened,
      createLessonOpened
    }),
    [setCreateLessonOpened, createLessonOpened]
  )

  useEffect(
    () => {
      setCreateLessonOpened(match.path === '/new' ? true : false)
    },
    [match.path]
  )

  return (
    <PromptsLayout>
      <LessonsContext.Provider value={value}>
        <Fragment>
          <PendingTeacherBar />
          <Switch>
            <Route
              exact
              path={['/', '/new', '/shared']}
              component={LessonsList}
            />
          </Switch>
        </Fragment>
      </LessonsContext.Provider>
    </PromptsLayout>
  )
}

export default injectSheet(styles)(Lessons)
